// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Resources } from '@shared/localizations/Resources';
import { LinkedSystem } from '../misc/LinkedSystem';
import { OrderHistoryItem } from '../cache/OrderHistoryItem';
import { TerceraLinkControlConstants } from '../UtilsClasses/TerceraLinkControlConstants';
import { MessageBoxType } from '@shared/utils/Interfaces/Screens/MessageBox.types';
import { TerceraMessageBox } from '../screen/TerceraMessageBox';
import { PanelNames } from '../UtilsClasses/FactoryConstants';
import { ApplicationPanelWithTable } from './ApplicationPanelWithTable';
import { DynProperty } from '@shared/commons/DynProperty';
import { DataCache } from '@shared/commons/DataCache';
import OrderHistoryPanelTemplate from '@front/templates/OrderHistoryPanelTemplate.html';
import { ReportManager } from '@shared/utils/Managers/ReportManager';
import { ReportType } from '@shared/commons/cache/AllowedReport';
import { createTagDictionary, NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class OrderHistoryPanel extends ApplicationPanelWithTable {
    constructor() {
        super();
        this.rangeSelectPanel = null;
        this.headerLocaleKey = 'panel.orderHistory';
        this.moreThanOneTTKey = 'panel.orders.menu.MoreOneSymbolInfoDisabled.tt'; // #95439
        this.noOneTTKey = 'panel.orders.menu.NoSymbolInfoDisabled.tt';
    }
    getType() {
        return PanelNames.OrderHistoryPanel;
    }
    oncomplete() {
        var _a;
        super.oncomplete();
        this.rangeSelectPanel = this.Controls.orderHistoryRangeSelect;
        this.rangeSelectPanel.getReportEvent.Subscribe(this.getOrderHistoryReport, this);
        this.rangeSelectPanel.updateSelectedRange();
        this.populateTableContextMenu();
        const qt = this.getQuickTable();
        qt.AddToEnd = false;
        qt.OnSelectionChanged.Subscribe(this.selectionChange, this);
        DataCache.AddOrderHistoryEvent.Subscribe(this.addNewOrderHistory, this);
        DataCache.RemovedOrderHistoryEvent.Subscribe(this.RemovedOrderHistory, this);
        this.UpdateShowTotalsStateChange(!!this.InitShowTotals);
        if ((_a = this.menuTagDict) === null || _a === void 0 ? void 0 : _a.ShowTotals) {
            this.menuTagDict.ShowTotals.checked = !!this.InitShowTotals;
        }
    }
    dispose() {
        DataCache.AddOrderHistoryEvent.UnSubscribe(this.addNewOrderHistory, this);
        DataCache.RemovedOrderHistoryEvent.UnSubscribe(this.RemovedOrderHistory, this);
        this.rangeSelectPanel.getReportEvent.UnSubscribe(this.getOrderHistoryReport, this);
        super.dispose();
    }
    selectionChange() {
        const qt = this.getQuickTable();
        const selectedRowsId = qt.selectedRowIds;
        if (isNullOrUndefined(selectedRowsId))
            return;
        let insId = '';
        // let accId = ''
        if (selectedRowsId.length > 0) {
            const row = qt.rows[selectedRowsId[0]];
            const item = row ? row.item : null;
            if (!isNullOrUndefined(item)) {
                const ins = item.GetCurrentInstrument();
                if (!isNullOrUndefined(ins)) {
                    insId = ins.GetInteriorID();
                }
                // let acc = item.GetCurrentAccount()
                // if (acc) accId = acc.BstrAccount
            }
            if (!insId) {
                TerceraMessageBox.Show(Resources.getResource('screen.reports.info'), Resources.getResource('general.InstrumentIsNotAvailableNow'), MessageBoxType.Info, null, null, false, true, null, { cantActionBeforeClose: true });
            }
        }
        this.symbolLink_Out(false, insId);
        // this.accountLink_Out(false, accId)
    }
    symbolLink_Out(newSubscriber, instrument) {
        if (isNullOrUndefined(instrument)) {
            return;
        }
        const color = this.get('symbolLinkValue');
        if (color !== TerceraLinkControlConstants.STATE_NONE) {
            LinkedSystem.setSymbol(color, instrument, newSubscriber);
        }
    }
    populateItemsDirect() {
        super.populateItemsDirect();
        const orderhistoryArr = DataCache.getOrderHistoryArray();
        for (let i = 0, len = orderhistoryArr.length; i < len; i++) {
            this.addNewOrderHistory(orderhistoryArr[i]);
        }
    }
    populateTableContextMenu() {
        const items = [];
        this.AddExportContextMenuItem(items);
        if (!Resources.isHidden('panel.orderHistory.print')) {
            items.push({
                type: NewContextMenuItemType.Default,
                text: 'screen.reports.print',
                event: this.printTable.bind(this)
            });
        }
        this.AddViewContextMenuItem(items);
        this.AddSymbolInfoContextMenuItemIfNeed(items);
        this.getQuickTable().setTableContextMenuItems(items);
        this.menuTagDict = createTagDictionary(items);
    }
    getOrderHistoryReport(startTime, finishTime) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.set('loading', true);
            ReportManager.reportsByComplited.set(ReportType.REPORT_ORDERBOOK, false);
            yield ReportManager.sendRequestByDate(ReportType.REPORT_ORDERBOOK, startTime, finishTime)
                .then((orderHistory) => {
                const qt = this.getQuickTable();
                if (isNullOrUndefined(qt))
                    return;
                qt.ClearRows();
                for (const oH of orderHistory) {
                    qt.AddItem(new OrderHistoryItem(oH));
                }
                if (LinkedSystem.accLinkingActive) {
                    qt.filterByAccountNumber(LinkedSystem.getAccount()); // отфильтруем по аккаунту позиции, если раскрылся лишний трейд
                }
            })
                .finally(() => {
                void this.set('loading', false);
            });
        });
    }
    addNewOrderHistory(orderHistory) {
        const qt = this.getQuickTable();
        if (isNullOrUndefined(qt))
            return;
        // TODO. Ugly.
        // qt.AddToEnd = false
        qt.AddItem(new OrderHistoryItem(orderHistory));
    }
    RemovedOrderHistory() {
        const qt = this.getQuickTable();
        if (isNullOrUndefined(qt))
            return;
        qt.ClearAll();
        this.populateItemsDirect();
    }
    Properties() {
        const properties = super.Properties();
        properties.push(new DynProperty('ShowTotals', this.getQuickTable().ShowTotals, DynProperty.BOOLEAN, DynProperty.HIDDEN_GROUP));
        return properties;
    }
    callBack(newProperties) {
        super.callBack(newProperties);
        this.InitShowTotals = DynProperty.getPropValue(newProperties, 'ShowTotals');
    }
    SetColumnsDefaultDisplayIndex(table) {
        table.columns[8].displayedIndex = 9;
        table.columns[9].displayedIndex = 10;
        table.columns[10].displayedIndex = 11;
        table.columns[11].displayedIndex = 12;
        table.columns[12].displayedIndex = 13;
        table.columns[13].displayedIndex = 14;
        table.columns[14].displayedIndex = 15;
        table.columns[15].displayedIndex = 8;
        table.columns[12].displayedIndex = 1;
        table.columns[11].displayedIndex = 2;
        table.columns[1].displayedIndex = 3;
        table.columns[2].displayedIndex = 4;
        table.columns[3].displayedIndex = 16;
    }
    SetColumnsColouringMode(table) { }
}
ApplicationPanelWithTable.extendWith(OrderHistoryPanel, {
    data: function () {
        return {
            isAccountLinkShow: true,
            isSymbolLinkShow: true
        };
    },
    partials: {
        bodyPartial: OrderHistoryPanelTemplate
    }
});
